const apiBaseURL = 'https://fwxu1tnnsb.execute-api.ap-northeast-1.amazonaws.com/production'

const Config = {
  cognitoSetting: {
    admin: {
      region: 'ap-northeast-1',
      IdentityPoolId: 'ap-northeast-1:d772cd21-9205-41ef-a295-4f2a7cd4e740',
      UserPoolId: 'ap-northeast-1_DafU9hGMb',
      ClientId: '4splsbe56kgtfr4as19849dvq6'
    },
    companyAdmin: {
      region: 'ap-northeast-1',
      IdentityPoolId: 'ap-northeast-1:eeaa2db1-b553-49ee-b919-93a7608dc1fb',
      UserPoolId: 'ap-northeast-1_ErimPmC2D',
      ClientId: '6rk67l9jvsjnvgkmi1nqeah0pk'
    },
    companyUser: {
      region: 'ap-northeast-1',
      IdentityPoolId: 'ap-northeast-1:1067437c-a559-4112-8ca6-cc67b1607406',
      UserPoolId: 'ap-northeast-1_BTaf1qEmY',
      ClientId: '47hbsncdq71sjdh8fraqsv7if9'
    }
  },
  adminSharedfileSetting: {
    AccountId: '022499048122',
    RoleArn: 'arn:aws:iam::022499048122:role/service-role/Katawaku_Admin',
    IdentityPoolId: 'ap-northeast-1:d772cd21-9205-41ef-a295-4f2a7cd4e740',
    Logins: 'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_DafU9hGMb',
    Bucket: 'katawaku-upload-files2'
  },
  adminApiUrl: {
    actionLog: apiBaseURL + '/admin/action-log',
    systemSettings: apiBaseURL + '/admin/system-settings',
    sharedFileDownlaod: apiBaseURL + '/admin/s3-presigned-url',
    emailChange: apiBaseURL + '/admin/email-change',
    userManagement: apiBaseURL + '/admin/user-management',
    estimation: apiBaseURL + '/admin/estimation',
    surveySetting: apiBaseURL + '/admin/survey-setting',
    surveyQuestionSetting: apiBaseURL + '/admin/survey-question-setting',
  },
  companyAdminApiUrl: {
    actionLog: apiBaseURL + '/company-admin/action-log',
    systemSettings: apiBaseURL + '/company-admin/system-settings',
    sharedFileDownlaod: apiBaseURL + '/company-admin/s3-presigned-url',
    emailChange: apiBaseURL + '/company-admin/email-change',
    companyUser: apiBaseURL + '/company-admin/company-user',
    selfUser: apiBaseURL + '/company-admin/self-user',
    selfUserNoLogin: apiBaseURL + '/company-admin/self-user-no-login',
    surveyAnswer: apiBaseURL + '/company-admin/survey-answer',
  },
  companyUserApiUrl: {
    actionLog: apiBaseURL + '/company-user/action-log',
    systemSettings: apiBaseURL + '/company-user/system-settings',
    sharedFileDownlaod: apiBaseURL + '/company-user/s3-presigned-url',
    emailChange: apiBaseURL + '/company-user/email-change',
    estimation: apiBaseURL + '/company-user/estimation',
    surveyAnswer: apiBaseURL + '/company-user/survey-answer',
    surveyAnswerNonLogin: apiBaseURL + '/company-user/survey-answer-non-login',
  },
  estimation: {
    nameOptions: [
      {
        name: '基礎型枠'
      },
      {
        name: '地下型枠'
      },
      {
        name: '地上普通型枠'
      },
      {
        name: '地上打放型枠'
      },
      {
        name: '地上化粧打放型枠'
      },
      {
        name: '捨てコン型枠'
      },
      {
        name: '打継目地型枠'
      },
      {
        name: '誘発目地型枠'
      },
      {
        name: 'スタイロフォーム打込み手間'
      }
    ],
    unitOptions: [
      {
        name: '㎡'
      },
      {
        name: 'm'
      },
      {
        name: '式'
      },
      {
        name: '箇所'
      }
    ]
  }
}

export default Config



// WEBPACK FOOTER //
// ./src/Config.js